module.exports = __webpack_public_path__ + "static/media/flashcard-outlined.17351964.svg";